import React, { useState } from 'react'
import { DialogSpin } from 'components'
import { Button } from '@mui/material'
import { useSendUnbalanceNotificationMutation } from 'features'
import { useDispatch } from 'react-redux'
import { successSnack, errorSnack } from 'features/snack-bar/snackSlice'
import { useOutletContext } from 'react-router-dom'

/**
 *
 * @param {*} _props
 * @returns
 */
export default function SetUnbalanceNotificationReview(_props) {
  const {
    togglerComponent: Component = { Button },
    children,
    togglerProps = {},
    rowData = {},
  } = _props
  const [open, setOpen] = useState(false)
  const { activeRow } = useOutletContext()

  const dispatch = useDispatch()

  function openDialog(e) {
    e.stopPropagation()
    setOpen(true)
  }
  function closeDialog() {
    setOpen(false)
  }

  const [revertTrans] = useSendUnbalanceNotificationMutation()

  function handleSubmit(data) {
    const mutation = revertTrans({
      unbalanceid: activeRow.unbalanceid,
      bctransaction: rowData,
    })
    mutation
      .then((response) => {
        if (response.data) {
          dispatch(
            successSnack({
              message: 'Notificación enviada correctamente',
            })
          )
          closeDialog()
        } else if (response.error.data) {
          let message = ''
          switch (response.error.data.message) {
            case 'unbalance_not_found':
              message = 'No se encontró el desbalance'
              break
            case 'mov_not_user':
              message = 'El movimiento no cumple con los requerimientos'
              break
            default:
              message = 'Error al enviar la notificación'
              break
          }
          dispatch(
            errorSnack({
              message: message,
            })
          )
          closeDialog()
        }
      })
      .catch((error) => {
        dispatch(errorSnack({ message: 'Error al enviar la notificación' }))
      })
  }

  const message = `¿Está seguro que desea enviar a revisar la transacción ${rowData.row.lastAction} \n con el hash ${rowData.row.txId}?`

  return (
    <>
      <Component onClick={openDialog} {...togglerProps}>
        {children}
      </Component>
      {open && (
        <DialogSpin
          open={open}
          handleClose={closeDialog}
          primaryButtonText="Enviar" //Label of the primary button
          secondaryButtonText="Cancelar" // Label of the cancel button
          title={`Enviar a revisión`} // 'Dialog title'
          message={message}
          onSubmit={handleSubmit} // Form submit action
        />
      )}
    </>
  )
}
